import React from "react";

function QueuesManagement() {
  return <div>QueuesManagement</div>;
}

export default QueuesManagement;
